import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _BudgetAccountantOperation, _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { _createProcess, _CustomProcessType, _PaymentHeader } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SelectTypeProcees } from "../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { CustomProcessTypeSeleect } from "../CustomProcessType/CustomProcessTypeSeleect";
import { InputDate } from "../../../theme/Input/InputDate";
import { BudgetAccountantOperationSelect } from "../BudgetAccountantOperation/BudgetAccountantOperationSelect";
import { Modal } from "../../../theme/Component/Modal";
import { Paymentitems } from "../BudgetAccountantOperation/Itemspago";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { JsonFormaterInput } from "../../../theme/Component/JsonFormaterInput";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { PrintJson } from "../../../theme/Component/PrintJson";


export const PaymentHeader = () => {


    const _documentFactory = useDataBean(_DocumentFactory);
    const _budgetAccountantOperation = useDataBean(_BudgetAccountantOperation);
    const [idOperation, setIDOperation] = useState<number>(undefined);
    const _customProcessType = useDataBean(_CustomProcessType);
    const _paymentHeader = useDataBean(_PaymentHeader);
    const _createCprocees = useDataBean(_createProcess);
    const [idPro, setIDPro] = useState<number>(0);
    const [existente, setExistente] = useState<boolean>(false);
    const [processType, setProcessType] = useState<any>(null);
    const [customProcces, setCustomProcces] = useState<any>(null);
    const [date, setDate] = useState<any>(_single.getCurrenDate());
    const [process, setProcess] = useState<any>({});
    const [bean, setBean] = useState<any>({});
    const [responseJson, setResponseJson] = useState<any>({});
    const [responseJsonservicio, setResponseJsonservicio] = useState<any>({});
    const [getpaymentheader, setGetpaymentheader] = useState<any>({});
    const [listaprocesoresponse, setListaprocesoresponse] = useState<any>([]);
    const [documentos, setDocumentos] = useState<any>([]);
    const [properties, setProperties] = useState<any>([]);
    const [modalmensajedelproceso, setModalmensajedelproceso] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalejecutarproceso, setModalejecutarproceso] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modallistapaymentheader, setModallistapaymentheader] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [itempago, setItempago] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [form, setForm] = useState<any>({
        Procces: undefined,
        Year: _single.getCurrenDate(),

    })
    const modalJson = useModal("JSON", MODAL_md);
    const modalDocumento = useModal("Documento", MODAL_XL);
    const modalDelete = useModal("Eliminar item", MODAL_SM);


    // useEffect(() => {
    //     if (process.IDProcess) {
    //         getPaymentHeaderCatalogvdos();
    //     }
    // }, [process])
    useEffect(() => {
        if (idOperation) {
            getPaymentHeaderProperties();
        }
    }, [idOperation])


    const CrearProcess = () => {

        _createCprocees.instance.createProcess(customProcces, date, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp);
                    setProcess(resp);
                }
            }
        )

    }
    const getProcess = () => {

        _paymentHeader.instance.getProcess(idPro).then(
            (resp: any) => {
                if (resp) {

                    setProcess(resp);
                }
            }
        )

    }

    const getPaymentHeaderCatalogvdos = () => {
        _paymentHeader.instance.getPaymentHeaderCatalogvdos(form.Procces, form.Year).then(
            (resp: any) => {
                let temp = resp;
                temp.forEach((item) => {

                    item.DataBeanProperties.CDDP = (item.DataBeanProperties.CDPMnemonic ?? "") + " " + (item.DataBeanProperties.CDPConsecutive ?? "");
                    item.DataBeanProperties.RPRESUPUESTAL = (item.DataBeanProperties.RPMnemonic ?? "") + " " + (item.DataBeanProperties.RPConsecutive ?? "");
                    item.DataBeanProperties.OBLIGACION = (item.DataBeanProperties.OBMnemonic ?? "") + " " + (item.DataBeanProperties.OBConsecutive ?? "");
                    item.DataBeanProperties.DOCCONTABLE = (item.DataBeanProperties.FCMnemonic ?? "") + " " + (item.DataBeanProperties.FCConsecutive ?? "");
                    item.DataBeanProperties.ORDEPAGO = (item.DataBeanProperties.IDSupplierPaymentOrder ?? "") + " " + (item.DataBeanProperties.SupplierPaymentOrderDate ?? "")
                });
                console.log(resp);
                setListaprocesoresponse(temp);
                setProcess(resp);
                // if (resp) {
                //     console.log(resp)
                //     setListaprocesoresponse(resp)
                //     setProcess(resp);

                // }
            }
        )
    }


    // const getLista = () => {
    //     employeeBonusVal.instance.getAppointmentsByEmployeeBonus(idEmploymentBonus).then(
    //         (resp) => {
    //             let bonuses = resp;
    //             bonuses.forEach((bonus) => {
    //                 bonus.DataBeanProperties.Apointmentself = (bonus.DataBeanProperties.Code ?? "") + " " + (bonus.DataBeanProperties.Name ?? "")
    //             });
    //             setLista(bonuses)
    //         }
    //     )
    // }
    const saveProperties = () => {
        console.log(process.IDProcess, getpaymentheader)


    }
    const getPaymentHeaderProperties = () => {
        // console.log(documentfactory)
        _paymentHeader.instance.getPaymentHeaderProperties(idOperation).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    let temp = { ...properties };
                    if (resp) {
                        let keys = Object.keys(resp);
                        keys.forEach(key => {
                            temp[key] = resp[key];
                        });
                        setProperties(temp);
                    }
                }
            }
        )

    }
    const getPaymentHeaderJson = () => {
        console.log(bean.IDPaymentHeader);
        if (bean.IDPaymentHeader > 0)
            _budgetAccountantOperation.instance.getPaymentHeaderJson(bean.IDPaymentHeader).then(
                (resp: any) => {
                    if (resp) {
                        setResponseJson(resp);
                        modalJson.open();
                    }
                }
            )

    }

    const createPaymentHeader = () => {

        _paymentHeader.instance.createPaymentHeader(process.IDProcess, properties).then(
            (resp: any) => {
                if (resp) {
                    getPaymentHeaderCatalogvdos();
                    setModallistapaymentheader({ ...modallistapaymentheader, "view": false });
                    setProperties({});
                }
            }
        )

    }
    const updatePaymentHeader = () => {

        _paymentHeader.updateCustonBean(properties).then(
            (resp: any) => {
                if (resp) {
                    getPaymentHeaderCatalogvdos();
                    setProperties({});
                }
            }
        )
        setModallistapaymentheader({ ...modallistapaymentheader, "view": false });

    }
    const deletePaymentHeader = () => {

        _paymentHeader.deleteItemVoid(bean.IDPaymentHeader).then(
            (resp: any) => {
                if (resp) {
                    getPaymentHeaderCatalogvdos();
                }
            }
        )
        modalDelete.close();

    }

    const getDocument = (idConsecutive: number, mnemonic: string, since: any) => {

        if (idConsecutive != null)
            _documentFactory.instance.getPdfAccountantDocument(idConsecutive, mnemonic, since, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp.DocumentURL);
                    if (resp.DocumentURL) {
                        setDocumentos(resp.DocumentURL);
                        modalDocumento.open();
                    } else {
                        toast.warning("No se encontraron documentos");
                    }
                }
            )
        else {
            toast.warning("No se encontraron documentos");
        }
    }
    const exportSupplierPaymentOrder = (IDSupplierPaymentOrder: number, SupplierPaymentOrderDate: string) => {

        if (IDSupplierPaymentOrder != null)
            _documentFactory.instance.exportSupplierPaymentOrder(IDSupplierPaymentOrder, SupplierPaymentOrderDate).then(
                (resp: any) => {
                    console.log(resp);
                    if (resp.length > 0) {
                        setDocumentos(resp);
                        modalDocumento.open();
                    } else {
                        toast.warning("No se encontraron documentos");
                    }
                }
            )
        else {
            toast.warning("No se encontraron documentos");
        }
    }
    const editarPaymentHeader = () => {
        setIDOperation(bean.IDBudgetAccountantOperation);
        setProperties(bean);
        setModallistapaymentheader({ ...modallistapaymentheader, "view": true, "name": "Editar Proceso de Pagos" });

    }

    const iconButtonsItemPaymentHeader = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { setProperties({}); setModallistapaymentheader({ ...modallistapaymentheader, "view": true, "name": "Crear Proceso de Pagos" }); } }
    ]
    const listaPaymenHeader = () => {
        const botones = [
            // { titulo: 'Items del Pago', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setItempago({ ...itempago, "view": true, "name": "Items del Pago" }) } },
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: editarPaymentHeader },
            // { titulo: 'Eliminar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalDelete.open() } },
            { titulo: 'Mensaje del Proceso', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModalmensajedelproceso({ ...modalmensajedelproceso, "view": true, "name": "Mensaje del Proceso" }) } },
            { titulo: 'Ver Solicitud Json', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: getPaymentHeaderJson },
            {
                titulo: 'Mostrar CDP', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { getDocument(bean.CDPIDDocument, bean.CDPMnemonic, bean.CDPDate) }
            },
            {
                titulo: 'Mostrar RP', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { getDocument(bean.RPIDDocument, bean.RPMnemonic, bean.RPDate) }
            },
            {
                titulo: 'Mostrar OB', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { getDocument(bean.OBIDDocument, bean.OBMnemonic, bean.OBDate) }
            },
            {
                titulo: 'Mostrar Contabilización', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { getDocument(bean.FCIDDocument, bean.FCMnemonic, bean.FCDate) }
            },
            {
                titulo: 'Mostrar Orden de Pago', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { exportSupplierPaymentOrder(bean.IDSupplierPaymentOrder, bean.SupplierPaymentOrderDate) }
            },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const headproceso = [
        { title: 'ID', property: 'IDPaymentHeader', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Names', visible: true },
        { title: 'Apellido', property: 'Surnames', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo de Operación', property: 'OperationType', visible: true },
        { title: 'Identificación', property: 'Nit', visible: true },
        { title: 'Código de Banco', property: 'BankingCode', visible: true },
        { title: 'Tipo de Cuenta', property: 'AccountType', visible: true },
        { title: 'Número de Cuenta', property: 'AccountNumber', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentType', visible: true },
        { title: 'Referencia de Pago', property: 'OrderNumber', visible: true },
        { title: 'Fecha de Contabilización', property: 'AccountantDate', visible: true },
        { title: 'Valor Transacción', property: 'PaymentValue', visible: true },
        { title: 'Procesado', property: 'IsValid', visible: true },
        { title: 'Fecha del Proceso', property: 'OBDate', visible: true },
        { title: 'Código', property: 'Mnemonic', visible: true },
        { title: 'Certificado de Disponibilidad Presupuestal', property: 'CDDP', visible: true },
        { title: 'Registro Presupuestal', property: 'RPRESUPUESTAL', visible: true },
        { title: 'Obligación', property: 'OBLIGACION', visible: true },
        { title: 'Documento Contable', property: 'DOCCONTABLE', visible: true },
        { title: 'Orden de Pago', property: 'ORDEPAGO', visible: true },
        // { title: 'Mensaje del Proceso', property: 'ErrorMessage', visible: true },






    ]

    const getBudgetAccountantOperationJsonRequest = () => {

        console.log(listaprocesoresponse)

        if (listaprocesoresponse.length === 0) {
            toast.error("La lista está vacía. No se puede obtener la respuesta.");
            return;
        }

        // Asegúrate de acceder al primer elemento de la lista y sus propiedades.
        const { IDProcess, Since } = listaprocesoresponse[0]?.DataBeanProperties || {};

        if (!IDProcess || !Since) {
            toast.error("No se encontraron valores válidos para IDProcess y Since.");
            return;
        }

        _budgetAccountantOperation.instance.getBudgetAccountantOperationJsonRequest(IDProcess, Since).then(
            (resp) => {
                if (resp) {
                    console.log("Respuesta obtenida:", resp);
                    setResponseJson(resp);
                    modalJson.open();
                }
            }
        ).catch((error) => {
            console.error("Error al obtener la respuesta:", error);
            toast.error("Ocurrió un error al obtener la respuesta.");
        });

    };
    const getBudgetAccountantOperationJsonResponse = () => {
        console.log(listaprocesoresponse)

        if (listaprocesoresponse.length === 0) {
            toast.error("La lista está vacía. No se puede obtener la respuesta.");
            return;
        }

        // Asegúrate de acceder al primer elemento de la lista y sus propiedades.
        const { IDProcess, Since } = listaprocesoresponse[0]?.DataBeanProperties || {};

        if (!IDProcess || !Since) {
            toast.error("No se encontraron valores válidos para IDProcess y Since.");
            return;
        }

        // Llamada al servicio con los valores extraídos.
        _budgetAccountantOperation.instance.getBudgetAccountantOperationJsonResponse(IDProcess, Since).then(
            (resp) => {
                if (resp) {
                    console.log("Respuesta obtenida:", resp);
                    setResponseJson(resp); // Guardar la respuesta en el estado.  
                    modalJson.open();
                }
            }
        ).catch((error) => {
            console.error("Error al obtener la respuesta:", error);
            toast.error("Ocurrió un error al obtener la respuesta.");
        });
    };


    const executeBudgetAccountantOperation = () => {
        console.log(listaprocesoresponse)

        if (listaprocesoresponse.length === 0) {
            toast.error("La lista está vacía. No se puede obtener la respuesta.");
            return;
        }

        // Asegúrate de acceder al primer elemento de la lista y sus propiedades.
        const { IDProcess, Since } = listaprocesoresponse[0]?.DataBeanProperties || {};

        if (!IDProcess || !Since) {
            toast.error("No se encontraron valores válidos para IDProcess y Since.");
            return;
        }
        _paymentHeader.instance.executeBudgetAccountantOperation(IDProcess, Since).then(
            (resp: any) => {
                console.log(resp);
                setResponseJson(resp); // Guardar la respuesta en el estado.  
                modalJson.open();
                // toast.success('Ejecutado Exitosamente');
                // setModalejecutarproceso({ ...modalejecutarproceso, "view": false, "name": "Ejecutar Proceso" });

            }
        )

    }


    return (
        <div className="row">
            <div className="col">

                <BasicPage titulo="Reporte de Procesos Masivos de Pago">
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">

                                    <div className="col-md-4">
                                        <InputDate label='Vigencia ' name='Year' value={form.Year} setDate={(e: any) => { setForm({ ...form, "Year": e }) }} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Proceso</label>
                                        <input type="text" name="Procces" className="form-control" value={form.Procces} onChange={(e) => { setForm({ ...form, "Procces": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-4 mt-4 p-2">
                                        <BasicButton eventClick={getPaymentHeaderCatalogvdos} icon="ri-search-line" children={"Buscar"} />
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-12 mt-5">
                                <div className="row">
                                    <div className="col-md-4"><BasicButton icon="" eventClick={getBudgetAccountantOperationJsonRequest}>Ver Json de Solicitud</BasicButton></div>
                                    <div className="col-md-4"><BasicButton icon="" eventClick={getBudgetAccountantOperationJsonResponse}>Ver Json de Respuesta</BasicButton></div>
                                    <div className="col-md-4"><BasicButton icon="" eventClick={executeBudgetAccountantOperation}>Ejecutar servicio</BasicButton></div>
                                </div>



                            </div>


                            <div className="col-md-12">
                                <BasicTable key={listaprocesoresponse} iconButtons={iconButtonsItemPaymentHeader}
                                    body={listaprocesoresponse} listButtons={listaPaymenHeader()} head={headproceso} rowSet={setBean} />
                            </div>

                        </div>

                    </>
                </BasicPage>

            </div>
            <div className="col-md-12">
                <Modal modal={modallistapaymentheader} updateModal={setModallistapaymentheader} eventModal={properties.IDPaymentHeader ? updatePaymentHeader : createPaymentHeader} onSubmitLabel="Guardar">

                    <div className="row">
                        <div className="col-md-12">
                            <BudgetAccountantOperationSelect idSelector={idOperation} onChange={(e) => setIDOperation(e)} />
                        </div>
                        <div className="col-md-12">

                            <div className="row">
                                {Object.keys(properties).map((row) => {
                                    return (
                                        <div className="col-md-6">
                                            <label>{row}</label>
                                            <input type="text" className="form-control" value={properties[row]}
                                                onChange={(e) => { setProperties({ ...properties, [row]: e.target.value }) }} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal modal={itempago} updateModal={setItempago}>
                    <>
                        {/* Asegúrate de extraer correctamente el IDPaymentHeader */}
                        <Paymentitems paymentHeader={bean} />
                        {/* <PrintJson json={listaprocesoresponse} /> */}
                    </>
                </Modal>
                <Modal modal={modalmensajedelproceso} updateModal={setModalmensajedelproceso}>
                    <>
                        <div>
                            {listaprocesoresponse.map((item, index) => {
                                const errorMessage = item.DataBeanProperties.ErrorMessage
                                    ? JSON.parse(item.DataBeanProperties.ErrorMessage)
                                    : null;

                                return (
                                    <div key={index}>
                                        <h3>ErrorMessage {index + 1}:</h3>
                                        {errorMessage ? (
                                            <PrintJson json={errorMessage} />
                                        ) : (
                                            <p>No ErrorMessage available</p>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </>
                </Modal>
                <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                    <>
                        <div className="col-md-12 mt-4">
                            <DocumentViewer list={documentos} />
                        </div>
                    </>
                </Modal>
                <Modal modal={modalJson.modal} updateModal={modalJson.setModal}>
                    <>
                        <JsonFormaterInput rows={20} inputType="string" value={responseJson} onChange={() => { }} returnType="object" _label="Respuesta" />
                    </>
                </Modal>
                <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deletePaymentHeader}>
                    Eliminar Item
                </ModalConfirm>
            </div>

        </div >
    )
}